'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaFastForwardOutline = function TiMediaFastForwardOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.3 14.5l6.9 6.7-6.9 6.7v-13.4z m-0.3-3.8c-1.7 0-3 1.3-3 3v15c0 1.6 1.3 3 3 3 0.8 0 1.6-0.4 2.1-0.9 4-3.8 9.9-9.6 9.9-9.6s-5.9-5.8-9.9-9.7c-0.6-0.5-1.3-0.8-2.1-0.8z m-14.7 3.8l6.9 6.7-6.9 6.7v-13.4z m-0.3-3.8c-1.7 0-3 1.3-3 3v15c0 1.6 1.3 3 3 3 0.8 0 1.6-0.4 2.1-0.9 4-3.8 9.9-9.6 9.9-9.6s-5.9-5.8-9.9-9.7c-0.6-0.5-1.3-0.8-2.1-0.8z' })
        )
    );
};

exports.default = TiMediaFastForwardOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-fast-forward-outline.js
// module id = 3133
// module chunks = 0